<template>
  <content-loader
    :height="475"
    :width="500"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="26" y="19" rx="5" ry="5" width="520" height="520" />
  </content-loader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader
  }
}
</script>
